import { useEffect, useRef } from "react";
import supabase from "../supabase";

const INACTIVITY_LIMIT_MS = 20 * 60 * 1000; // 20 minutes of no activity → auto logout
const ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];

// Signs the user out only after real inactivity (or manual logout / tab close via
// sessionStorage). Does NOT log out on navigation between admin and public pages.
export default function AdminSessionGuard() {
    const timerRef = useRef(null);

    useEffect(() => {
        const resetTimer = () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(async () => {
                const { data } = await supabase.auth.getSession();
                if (data.session) {
                    await supabase.auth.signOut();
                }
            }, INACTIVITY_LIMIT_MS);
        };

        resetTimer();
        ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, resetTimer));

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, resetTimer));
        };
    }, []);

    return null;
}